import { EmployeeRole } from '@/api/apis/resources';
import { Uuid } from '@/api/types';

export enum WarningType {
  Match = 'match',
  Primary = 'primary',
  ClinicalLead = 'clinical-lead',
  MissingShift = 'missing-shift',
}

export type ResourceWarning = {
  id: string;
  type: WarningType;
  employeeId: Uuid;
  role?: EmployeeRole;
  message: string;
};
